/**
 * 指定数値の倍数チェック定義
 */
window.Parsley.addValidator('multipleOf', {
  requirementType: 'integer',
  validateNumber: function (value, requirement) {
    return value % requirement === 0;
  },
  messages: {
    ja: '数量は%s単位でご指定ください。'
  }
});
